
import type { AreaInfoDetail, BranchParkingConfig, ParkingFeeApiResponse, ParkingFeeDetail, ParkingRecord } from '@/services/dto/parking';
import DetailContent from './DetailContent';
import HeaderHorizontal from './HeaderHorizontal';
import HeaderVertical from './HeaderVertical';

interface ParkingDetailScreenProps {
    result: ParkingRecord;
    onBack: () => void;
    isUseLocation?: boolean;
    areaInfo: AreaInfoDetail | null;
    parkingFeeApiData: ParkingFeeDetail | null;
    parkingFeeData: BranchParkingConfig | null;
    handleDirectionGuide: () => void;
    rawData: ParkingFeeApiResponse | null;
}

export default function ParkingDetailScreen({ result, onBack, isUseLocation, areaInfo, parkingFeeApiData, parkingFeeData, handleDirectionGuide, rawData }: ParkingDetailScreenProps) {
    return (
        <div
            className={`widescreen:flex-row widescreen:justify-center widescreen:items-start widescreen:gap-[calc(80*var(--vw-unit))] widescreen:shrink-0 flex w-full flex-col items-center gap-[calc(40*var(--vh-unit))] fullscreen:widescreen:h-[calc(759*var(--vh-unit))] fullscreen:h-[calc(1235*var(--vh-unit))] widescreen:overflow-y-hidden widescreen:h-[calc(599*var(--vh-unit))] max-h-full overflow-y-auto scrollbar-custom-gray-99938f scrollbar-w-4`}
        >            
                {/* Header Vertical */}
                <HeaderVertical
                    result={result}
                    isUseLocation={isUseLocation}
                    areaInfo={areaInfo}
                />

                {/* Detail content */}
                <DetailContent
                    rawData={rawData}
                    isUseLocation={isUseLocation}
                    parkingFeeApiData={parkingFeeApiData}
                    parkingFeeData={parkingFeeData}
                    onBack={onBack}
                    handleDirectionGuide={handleDirectionGuide}
                />

                {/* Header Horizontal */}
                <HeaderHorizontal
                    result={result}
                    isUseLocation={isUseLocation}
                    areaInfo={areaInfo}
                    onBack={onBack}
                    handleDirectionGuide={handleDirectionGuide}
                />
            </div>
    );
}
